<template>
  <div>
    <div class="box_fl">
      <div class="w_1200 flex_fw">
        <!-- 一级目录 -->
        <div
          class="category-trigger"
          @mouseenter="showCategories = true"
          @mouseleave="showCategories = false"
        >
          <div class="container">
            <div class="div_bq">{{ $t("index.all_goods") }}</div>
            <div
              class="div_bq item"
              v-for="(item, index) in cates"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
          <!-- 根据状态显示商品分类 -->
          <div v-show="showCategories" class="category-container">
            <el-row :gutter="20" v-if="cates.length > 0">
              <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="4">
                <div class="div_fl" style="width:auto">
                  <div style="color: #4679f0" class="flex" @click="resetCate">
                    <i class="el-icon-menu"></i>
                    <div class="f14">{{ $t("index.all_cate") }}</div>
                  </div>
                  <div
                    class="category-item"
                    style="margin-top: 10px; "
                  >
                    <div
                      style="
                        margin-top: 10px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                      id="nameColor"
                      :class="[index == cur_fidx ? 'div_name f14' : 'f14']"
                      v-for="(item, index) in cates"
                      :key="index"
                      @click="selectFirst(index)"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="18" :xl="20">
                <div class="div_fl w_800" >
                  <div style="color: #4679f0" class="flex">
                    <div class="f14">
                      {{ cates[cur_fidx == -1 ? 0 : cur_fidx].name }}
                    </div>
                  </div>
                  <div class="flex_fw category-item" style="margin-top: 10px">
                    <div
                      style="margin: 10px 20px 0 0"
                      class="f14"
                      v-for="(item, index) in cates[
                        cur_fidx == -1 ? 0 : cur_fidx
                      ].children"
                      :key="index"
                      @click="selectSecond(index)"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="w_1200">
      <div></div>
      <div class="m_10">
        <el-input
          :placeholder="$t('search.placeholder')"
          v-model="keyword"
          class="input-with-select"
        >
          <template #append>
            <el-button
              type="primary"
              icon="el-icon-search"
              style="background-color: #4679f0; color: #fff; height: 40px"
              @click="init()"
              >{{ $t("search.btn_txt") }}</el-button
            >
          </template>
        </el-input>
      </div>
      <div
        style="margin-top: 20px; overflow-y: auto"
        class="m_10"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="10"
      >
        <el-row :gutter="20">
          <el-col
            :xs="12"
            :sm="12"
            :md="8"
            :lg="6"
            :xl="4"
            v-for="(item, index) in goods"
            :key="index"
          >
            <div class="grid-content">
              <router-link :to="{ name: 'detail', query: { id: item.id } }">
                <img class="img_sp" :src="item.thumb" alt="" />
              </router-link>
              <div style="padding: 10px">
                <div
                  class="f14"
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  {{ item.name }}
                </div>
                <div class="flex_js top_up" @click="goView(index)">
                  <div class="f12 red" style="display: none;">
                    {{ $t("goods.price")
                    }}{{
                      item.price_ext == "" ? "" : "(" + item.price_ext + ")"
                    }}:${{ item.price }}
                  </div>
                </div>
                <div style="margin-top: 10px; text-align: center">
                  <el-button
                    type="primary"
                    round
                    v-if="item.order_id == ''"
                    icon="el-icon-star-on"
                    size="mini"
                    >{{ $t("goods.btn_submit_seek") }}</el-button
                  >
                  <el-button
                    v-else
                    round
                    icon="el-icon-star-off"
                    size="mini"
                    style="padding: 5px"
                    >{{ $t("goods.btn_cancel_seek") }}</el-button
                  >
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndex } from "@/api/index";
export default {
  name: "IndexPage",
  data() {
    return {
      cates: [],
      goods: [],
      keyword: "",
      cur_fidx: -1,
      cur_sidx: -1,
      input3: "",
      showCategories: false, // 控制分类显示状态
      iscolor: true,
      first_load: true,
      loading: false,
      page: 1,
      pages: 1,
    };
  },
  created() {
    console.log("created");
    // this.init()
  },
  methods: {
    init() {
      getIndex({
        keyword: this.keyword,
        fid: this.cur_fidx == -1 ? "" : this.cates[this.cur_fidx].id,
        sid:
          this.cur_sidx == -1
            ? ""
            : this.cates[this.cur_fidx].children[this.cur_sidx].id,
      }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.cates = res.data.cates;
          this.goods = res.data.goods;
        }
      });
    },
    loadMore() {
      if (this.page > this.pages) {
        this.loading = false;
        return;
      }
      if (this.loading) return;
      this.loading = true;
      getIndex({
        keyword: this.keyword,
        fid: this.cur_fidx == -1 ? "" : this.cates[this.cur_fidx].id,
        sid:
          this.cur_sidx == -1
            ? ""
            : this.cates[this.cur_fidx].children[this.cur_sidx].id,
        page: this.page,
        limit: 12,
      }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          if (this.first_load) {
            this.cates = res.data.cates;
            this.first_load = false;
            this.goods = res.data.goods;
            this.pages = res.data.pages;
          } else {
            this.goods = [...this.goods, ...res.data.goods];
          }
          this.page++;
          this.loading = false;
        }
      });
    },
    resetCate() {
      this.cur_fidx = -1;
      this.cur_sidx = -1;
      this.init();
    },
    selectFirst(index) {
      this.cur_fidx = index;
      this.cur_sidx = -1;
      this.init();
    },
    selectSecond(index) {
      this.cur_sidx = index;
      this.init();
    },
    goView(index) {
      this.$router.push({
        name: "detail",
        query: {
          id: this.goods[index].id,
        },
      });
    },
  },
};
</script>

<style>
.container {
  display: flex;
  flex-wrap: nowrap;
  /* 不换行 */
  overflow-x: auto;
  /* 允许水平滚动 */
  width: 1200px;
  /* 或者你想要的固定宽度 */
}

.item {
  flex-shrink: 0;
  /* 防止缩小 */
  margin-right: 10px;
  /* 根据需要调整间距 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* 防止换行 */
}

::-webkit-scrollbar {
  display: none !important;
  /* 隐藏横向滚动条 */
}
.w_800{
  width: 850px;
}
.category-item div:hover {
  color: #4679f0;
  cursor: pointer;
}

.div_name {
  color: red;
}

.div_fl {
  
  min-height: 200px;
  border: 1px solid #cdcdcd;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 15px;
}

.category-trigger {
  position: relative;
  display: inline-block;
}

@media (max-width: 768px) {
  .category-trigger {
    position: relative;
    display: inline-block;
    width: 100% !important;
  }
  .w_800{
  width: auto !important;
}
  .container {
    display: flex;
    flex-wrap: nowrap;
    /* 不换行 */
    overflow-x: auto;
    /* 允许水平滚动 */
    width: 100% !important;

    /* 或者你想要的固定宽度 */
  }
  .div_fl {
    width: auto;
    min-height: 100px !important;
    border: 1px solid #cdcdcd;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 10px !important;
  }

  .category-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 10px !important;
    border-radius: 10px;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: white;
    border: 1px solid #ddd;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    z-index: 1000;
    width: auto !important;
  }

  .div_bq {
    padding: 5px !important;
    cursor: pointer;
    min-width: 80px !important;
  }
}

.category-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 20px;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid #ddd;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: 1200px;
}

.div_bq {
  padding: 10px;
  cursor: pointer;
  min-width: 80px;
}

.box_fl {
  padding: 10px;
  margin-bottom: 10px;
  background-color: #cdcdcd;
}

.grid-content {
  border-radius: 15px;
  margin-bottom: 20px;
  border: 1px solid rgba(187, 187, 187, 1);
}

.img_sp {
  width: 100%;
  height: 200px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.el-icon-star-on {
  font-size: 14px;
}

.el-icon-star-off {
  font-size: 14px;
}
</style>